/*
 * Serviço de acesso ao back end para as validação de campo de valor único (Unique Validation).
 */
angular.module("avlib").provider('uniqueValidationService', function() {

	var validations = {};

	// Método a ser invocado no configurador do servide provider para definir um campo de valor único
	this.setValidationCallback = function(validationField, validationService, validationMethod) {
		validations[validationField] = {
		 	serviceName: validationService,
		 	methodName: validationMethod
		};
	};

	this.$get = ["$log", "$injector", function uniqueValidationFactory($log, $injector) {

		var _check = function(validationField, value){
			// Obtendo as configurações de validação apropriadas para o campo a ser validado:
			var validationConfig = validations[validationField];

			// Se a aplicação cliente não configurou a validação para o campo, notificamos:
			if (!validationConfig){
				$log.error("Unique Validation Service: Não foi encontrada configuração de "
					+"validação para campos do tipo ["+validationField+"]");
				return null;
			}

			// Obtendo o serviço de validação apropriado:
			var serviceName = validationConfig.serviceName;
			var service = $injector.get(serviceName);

			// Executando o método de validação aproriado:
			var methodName = validationConfig.methodName;

			return service[methodName](value);
		};

		return {
			check: _check,
		};
	}];
});